module.exports = __webpack_public_path__ + "static/media/prev.e5c225af.svg";